import React from 'react'
import './styles.scss'
import { DocumentCategory } from 'share/domain/document'
import { Button } from 'react-bootstrap'

interface CategoryDocumentListProps {
  documentCategories: DocumentCategory[]
  showButton?: boolean
  showStatus?: boolean
  sorted?: boolean
  onClick: (category: DocumentCategory) => void
}

export const getStatus = (status?: string, withIcon = false): string => {
  switch (status?.toLowerCase()) {
    case 'pending':
      return `${withIcon && 'mdi-clock-outline'} yellow`
    case 'rejected':
      return `${withIcon && 'mdi-alert-rhombus-outline'} red`
    case 'accepted':
      return `${withIcon && 'mdi-check-circle-outline'} green`
    case 'complete':
      return `${withIcon && 'mdi-check-circle-outline'} green`
    default:
      return ''
  }
}

const CategoryDocumentList = ({
  documentCategories,
  showButton = false,
  showStatus = false,
  sorted = false,
  onClick
}: CategoryDocumentListProps): JSX.Element => {
  const sortedCategories = [...documentCategories]

  const index = documentCategories.findIndex(
    (el) => el.name === 'General Documents'
  )
  if (index > 0 && sorted) {
    const generalCategory = documentCategories[index]
    sortedCategories.splice(index, 1)
    sortedCategories.sort((a, b) => (a.name > b.name && 1) || -1)
    sortedCategories.unshift(generalCategory)
  }

  return (
    <ul data-testid='submit-docs-list' className='ui-docs-list mb-0'>
      {sortedCategories &&
        sortedCategories.map((category: DocumentCategory) => (
          <li
            data-testid='submit-docs-list-item'
            key={category.id}
            onClick={() => {
              if (!showButton) onClick(category)
            }}
          >
            <div className='ui-docs-item'>
              <p>{category.name}</p>
              <span className={`${showStatus && getStatus(category.status)}`}>
                {showStatus ? category.status : ''}
              </span>
              <div className='ml-n3 col-12 text-truncate'>
                <span>{category.subcategoryList}</span>
              </div>
            </div>

            <div className='ui-docs-status'>
              <span className={`mdi ${getStatus(category.status, true)}`} />
            </div>
            <div className='ui-docs-button'>
              {!showButton ? (
                <span className='mdi mdi-chevron-right' />
              ) : (
                <Button variant='primary' onClick={() => onClick(category)}>
                  View
                </Button>
              )}
            </div>
          </li>
        ))}
    </ul>
  )
}

export default CategoryDocumentList
